import React, { memo } from "react";
import useStyles from "../../../../styles";
import InputSearchProduct from "../InputSearchProduct";

import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Images } from "config/images";

const HeaderHomePage = ({
	total,
	handleSearchProduct,
	mainClasses,
	subClasses,
	style
}) => {
	const classes = useStyles();
	const history = useHistory();
	return (
		<Grid classes={mainClasses} style={style}>
			<Grid classes={subClasses}>
				<Grid classes={{ root: classes.searchProduct }}>
					<InputSearchProduct
						handleSearchProduct={handleSearchProduct}
					/>
					<img
						src={
							total > 0
								? Images.icNotificationActive
								: Images.icNotification
						}
						alt={"icNotification"}
						className={classes.btnNotification}
						onClick={() => {
							history.push("/notification");
						}}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(HeaderHomePage);
